import * as React from 'react';
import * as moment from 'moment';
import { IDonorRegistration } from '@nkr/models/donor-registration';
import { Col, Label, Panel, Row } from 'react-bootstrap';
import { getString } from './renderers';
import { AlternateDonationOptionsDescriptions } from './content';
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from '../../styles';

interface IProps {
    data: IDonorRegistration,
}

const DonatingForInfo = ({ data }: IProps) => {
    return (
        <div id='donating-for-info' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>Donating for {data.recipientLocation}</span>
                </div>
                {data.recipientLocation !== 'Local Recipient' && (<>
                    <Row>
                        <Col xs={6} sm={4}>
                            <strong>Recipient's Center:</strong>
                        </Col>
                        <Col xs={6} sm={8} style={data.recipientCenterIsNkrParticipant === false ? { color: '#a94442', fontWeight: 'bold' } : undefined}>
                            {data.recipientCenterName == null || data.recipientCenterName == '' ? '[unknown]' : data.recipientCenterName}
                        </Col>
                    </Row>

                    {data.recipientCenterIsNkrParticipant === false && (
                        <Row>
                            <Col xs={12} smOffset={4} sm={8}>
                                <span className='label label-danger'>Not an NKR Member center</span>
                            </Col>
                        </Row>
                    )}

                    <Row>
                        <Col xs={6} sm={4}>
                            <strong>Recipient Coordinator:</strong>
                        </Col>
                        <Col xs={6} sm={8}>
                            {data.recipientCenterCoordinator == null || data.recipientCenterCoordinator.fullName == '' ? '[unknown]' : data.recipientCenterCoordinator.fullName}
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={6} sm={4}>
                            <strong>Recipient Coordinator Phone#:</strong>
                        </Col>
                        <Col xs={6} sm={8}>
                            {data.recipientCenterCoordinatorPhone == null || data.recipientCenterCoordinatorPhone == '' ? '[unknown]' : data.recipientCenterCoordinatorPhone}
                        </Col>
                    </Row>
                </>

                )}

                {data.isRemoteDonationPreferred && data.remoteCenterId !== data.centerId && (
                    <Row>
                        <Col xs={6} sm={4}>
                            <strong>Preferred Remote Donation Center:</strong>
                        </Col>
                        <Col xs={6} sm={2}>
                            {getString(data.recipientCenterName)}
                        </Col>
                    </Row>
                )}

                <Row>
                    <Col xs={6} sm={4}>
                        <strong>Recipient's Name:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {data.ddRecipFirstName} {data.ddRecipLastName}
                    </Col>
                    <Col xs={6} sm={4}>
                        <strong>Recipient's DOB:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {data.ddKnowsRecipDob ? moment(data.ddRecipDob).format('MM/DD/YYYY') : 'Doesn\'t know'}
                    </Col>
                </Row>

                <Row>
                    <Col xs={6} sm={4}>
                        <strong>Recipient's Status:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {data.ddRecipUrgency ?? <Label>Unknown</Label>}
                    </Col>
                    <Col xs={6} sm={4}>
                        <strong>How DD knows Recip:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {data.ddRelationshipToPatient}
                    </Col>
                </Row>

                <Row>
                    <Col xs={6} sm={4}>
                        <strong>DD communicates w/ Recip:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {data.ddFrequencyOfCommunication}
                    </Col>
                </Row>

                <div>
                    {data.ddAlternateDonationOptions != null && data.ddAlternateDonationOptions.length > 0 && (
                        <Panel.Footer>
                            <Row style={{ marginBottom: 0 }}>
                                <Col xs={6} sm={4}>
                                    <strong>Candidate is also interested in:</strong>
                                </Col>
                                <Col xs={6} sm={8}>
                                    {data.ddAlternateDonationOptions.map((value, index) =>
                                        <React.Fragment key={index}>
                                            <Label bsStyle='success' bsSize='sm'>{AlternateDonationOptionsDescriptions[value]}</Label>
                                        </React.Fragment>
                                    )}
                                </Col>
                            </Row>
                        </Panel.Footer>
                    )}
                </div>
            </div>
        </div>
    );
}

export default DonatingForInfo;